 function getParametersFromUrl() {
     var url = window.location.href;
     if (url.lastIndexOf('?') !== -1) {
        var urlParameters = url.substring(url.lastIndexOf('?') + 1);
         if (urlParameters.length > 0) {
             var splittedParams = urlParameters.split('&');
             var parameters = splittedParams.map(function (val) {
                 return val.split('=');
             });
             return parameters;
         }
     }
     return [];
 }
 function getURLParameter(sParam) {
     var sPageURL = window.location.search.substring(1);
     var sURLVariables = sPageURL.split('&');
     for (var i = 0; i < sURLVariables.length; i++) {
         var sParameterName = sURLVariables[i].split('=');
         if (sParameterName[0] === sParam) {
             return sParameterName[1];
         }
    }
     return undefined;
 };
 function getTid() {
     var tid = getURLParameter('tid');
    return tid;
 }
 function getCid() {
     var cid = getURLParameter('cid');
     return cid;
 }
 function getStore() {
     var store = getURLParameter('store');
       return store;
}
 function getToken() {
     var token = getURLParameter('token');
     return token
 }

function getHostName() {

    return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + '/ewa/kekspos';
    // return 'http://localhost:3001/ewa/kekspos';
}

function getHostNameTPS() {

    return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + '/ewa/tps';
    // return 'http://localhost:3001/ewa/kekspos';
}

// function getContextName() {
//     var url = window.location.href;
//     var startIndex = url.indexOf('//') + 2;
//     var contextStartIndex = url.indexOf('/', startIndex);
//     var contextEndIndex = url.indexOf('/', contextStartIndex + 1);
//     var contextName = url.substring(contextStartIndex, contextEndIndex);
//     if(contextEndIndex === -1) {
//         return '';
//     }    
//     return contextName;
// }
// function redirectTo(page) {
//     window.location.replace(getHostname() + getContextName() + '/' + page + '.html');
// }

 export { getTid, getCid, getStore, getToken, getHostName, getHostNameTPS };